





















































import {Component, Emit, Prop, Vue, Watch} from "vue-property-decorator";
import { VueEventTypes } from "@/events/AppEvent";
import DialogCloseNavigation from "@/components/molecules/DialogCloseNavigation.vue";
import ImageSlideViewer from "@/components/organisms/media/ImageSlideViewer.vue";
import ProductArticleTexts from "@/components/organisms/contents-texts/ProductArticleTexts.vue";
import {ProductContentsParams} from "@/interfaces/ContentsParams";
import vuescroll from "vuescroll";
import { innerVueScrollOption } from "@/libs/Options";

@Component({
  components: {
    ProductArticleTexts,
    ImageSlideViewer,
    DialogCloseNavigation,
    vuescroll
  }
})
export default class ProductArticleDialog extends Vue {
  @Prop({ default: false }) isShown: boolean;
  @Prop({ default: '#191919' }) cardColor: string;
  @Prop({ default: null }) contents: ProductContentsParams;

  private scrollOptions = innerVueScrollOption;

  /**
   * 表示・非表示プロパティ
   * プロパティバインドisShownを使って表示
   * 非表示時は'close'をEmitして双方向バインディングを実現する
   *
   */
  get isShownDialog (): boolean {
    return this.isShown;
  }
  set isShownDialog (value: boolean) {
    if (!value) {
      if (this.isShown) {
        this.onCloseDialog();
      }
    }
  }

  get publicPath (): string {
    return this.$store.state.publicPath;
  }

  get isSmp (): boolean {
    return this.$store.state.isSmp;
  }

  get isTablet (): boolean {
    return this.$store.state.isTablet;
  }

  get imageAspectRatio (): number {
    if (this.contents.imageType == 'landscape') {
      return 1.5;
    }
    else if (this.contents.imageType == 'square') {
      return 1;
    }
    else if (this.contents.imageType == 'portrait') {
      return 0.6667;
    }
    else {
      return 1.5;
    }
  }

  @Watch('isShown')
  onShown (newValue: boolean, oldValue: boolean) {
    if (newValue) {
      console.log('Show Dialog');
      const slider: ImageSlideViewer = <ImageSlideViewer> this.$refs.imageSlideViewer;
      // @ts-ignore
      slider.start();
    }
  }

  /* Close Event Emit */
  @Emit(VueEventTypes.CLOSE_CONTENTS)
  onCloseDialog (): void {
    console.log('Close Product Dialog');
    // 非表示アニメーション後にイメージビューワーをリセット
    setTimeout(() => {
      console.log('Contents Reset');
      // イメージスライダーをリセット
      const slider: ImageSlideViewer = <ImageSlideViewer> this.$refs.imageSlideViewer;
      // @ts-ignore
      slider.reset();
      // スクロールをリセット
      const scroll: vuescroll = <vuescroll> this.$refs.vScroll;
      scroll.scrollTo({ y: 0 }, 0);
    }, 300);
  }
}
